import NoProficiencyIcon from './NoProficiencyIcon';

export default NoProficiencyIcon;
export { NoProficiencyIcon };
